module.exports = __webpack_public_path__ + "static/media/ACOMODO-new.99b9ed78.png";